namespace $.$$ {
	export class $giper_baza_app extends $.$giper_baza_app {
		
		@ $mol_mem
		auto() {
			this.$.$giper_baza_glob.home()
			return []
		}
		
	}
}
